import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import flowioIcon from 'assets/svgIcons/flowioIcon.svg';
import { ButtonsWrapper, HeaderButton, Logo, Title, Wrapper } from './Header.styles';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveHistoryId, toggleFullScreen, toggleOpen } from 'store/entities/chatbot/actions';
import { selectFullScreen } from 'store/entities/chatbot/selectors';

import { History } from './History';
import type { ConversationMeta, Message } from 'types';

export interface HeaderProps {
  messages: Message[];
  setMessages: (messages: Message[]) => void;
  setConversation: (conversation: ConversationMeta) => void;
  onNewChat?: () => void;
}

const HeaderBase = ({ onNewChat, ...rest }: HeaderProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const fullScreen = useSelector(selectFullScreen());

  const handleClose = useCallback(() => {
    dispatch(toggleOpen());
    dispatch(setActiveHistoryId(null));
  }, [dispatch]);

  const handleToggleFullScreen = useCallback(() => {
    dispatch(toggleFullScreen());
  }, [dispatch]);

  return (
    <Wrapper>
      <Title>
        <Logo src={flowioIcon} alt="" />
        {t('user.chat.assistantTitle')}
      </Title>
      <ButtonsWrapper>
        <HeaderButton title={t('user.chat.newChat')} onClick={onNewChat}>
          ✍️ {t('user.chat.newChat')}
        </HeaderButton>
        <History {...rest} />
        <HeaderButton onClick={handleToggleFullScreen} title={fullScreen ? t('user.chat.restoreTitle') : t('user.chat.maximizeTitle')}>
          {fullScreen ? '↘' : '⤢'}
        </HeaderButton>
        <HeaderButton onClick={handleClose} title={t('user.chat.closeTitle')}>
          X
        </HeaderButton>
      </ButtonsWrapper>
    </Wrapper>
  );
};

export const Header = memo(HeaderBase);
